<template>
  <div class="loan-container height-100">
    <v-slide-y-transition group tag="div" class="height-100">
      <section key="title" v-if="ready" class="content line-height--14">
        <p class="font-size--16 font-weight-bold color--nice-grey mb-0">잠깐만 기다려 주세요!</p>
        <h1 class="font-size--24 font-weight-black color--nice-black">
          나한테 딱 맞는 사업자 신용대출을<br v-if="$vuetify.breakpoint.width > 320" />
          찾는 중입니다 ......
          <!-- <br v-if="$vuetify.breakpoint.width > 320" />몇가지 정보가 필요합니다. -->
        </h1>
      </section>

      <!-- <v-layout class="px-3" key="progress-circular" justify-center align-center style="height: 70%">
        <div class="loader">Loading...</div>
      </v-layout> -->
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ready: false,
    }
  },
  mounted() {
    this.ready = true
  },
}
</script>
